(ns ductile.ui.vehicle-call-off
  (:require [clojure.set :as set]
            [clojure.string :as str]
            [ductile.ui.components :as ui]
            [ductile.ui.components.combobox :as combobox]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.http :as http]
            [ductile.ui.locale :refer [tr]]
            [ductile.ui.router :as router]
            [goog.string.format]
            [nextjournal.log :as log]))

(def !destinations (deframe/!get-in [::state :destinations]))
(def !vin->call-off-data (deframe/!get-in [::state :vin->call-off-data]))

(defn set-call-off-data! [vin k v]
  (deframe/tx! [[:op/assoc-in (into [::state :vin->call-off-data vin] k) v]]))

(defn find-service-by-label [services service-label]
  (some (fn [service]
          (when (= service-label (ui/service-label service))
            service))
        services))

(defn location-code-badge [location-code]
  [:span.bg-indigo-700.rounded-full.text-white.tracking-wide
   {:key location-code
    :data-testid (str "location-code-" location-code)
    :class "text-[11px] px-[7px] py-[2px] group-data-[selected=true]:bg-indigo-200 group-data-[selected=true]:text-indigo-700"}
   location-code])

(defn all-location-codes [destination]
  (set/union (:external.bmw/location-codes destination)
             (:external.kia/location-codes destination)))

(defn item-view [{:as destination :address/keys [street postcode city]}]
  (let [location-codes (all-location-codes destination)]
    [:div.text-left.leading-snug.flex-grow
     (if (or (seq location-codes) (:address/name destination))
       [:div.font-medium.flex.justify-between.gap-1
        (when (:address/name destination)
          [:<>
           (:address/name destination) [:br]
           (:address/street destination) [:br]
           (:address/postcode destination) " "
           (:address/city destination)])
        (when (seq location-codes)
          [:div
           (into [:span.inline-flex.gap-1]
                 (map (fn [location-code]
                        [location-code-badge location-code]))
                 location-codes)])]
       (:ductile/id destination))]))

(def compound-name->country-code
  {"Krefeld" "DEU"
   "Eitting" "DEU"
   "Fiumicino" "ITA"
   "Lonato" "ITA"
   "Ravenna" "ITA"
   "Civitavecchia" "ITA"})

(defn fahrzeug-row [{compound-name :compound/name} fahrzeug]
  (let [value->label (merge {"" ""}
                            (into {}
                                  (map (fn [destination]
                                         [(:ductile/id destination)
                                          (if-let [codes (all-location-codes destination)]
                                            (str (str/join "+" codes) " - " (:address/name destination))
                                            (:address/name destination))]))
                                  @!destinations))
        label->value (into {} (map (fn [[k v]] [v k]) value->label))
        country-code (compound-name->country-code compound-name)]
    [:tr.border-b.last:border-b-0.hover:bg-yellow-50.odd:bg-slate-50.even:bg-white
     [:td.px-3.py-2.border-r.text-xs
      [ui/link
       {:href (str "/compound/" compound-name "/vehicle/" (:vehicle/vin fahrzeug))}
       (:vehicle/vin fahrzeug)]
      (when (:vehicle/model fahrzeug)
        [:span.text-slate-500.block.mt-1 {:class "text-[12px]"} (:vehicle/model fahrzeug)])]
     [:td.px-2.py-2.border-r
      [:div.flex {:data-testid (str (:vehicle/vin fahrzeug) "-destination")}
       [ui/locations-autocomplete
        {:component-key (:vehicle/vin fahrzeug)
         :filter (fn [{:keys [search-text search-by-dealer-code?]}]
                   (deframe/call-lambda
                    {:result-path (ui/locations-autocomplete-path (:vehicle/vin fahrzeug) [:filtered-items])}
                    'ductile.locations/search*
                    {:search-params
                     (cond-> {:country/code country-code}
                       (and search-by-dealer-code? (= "DEU" country-code))
                       (assoc :external.bmw/location-codes {:ductile.entity-search/regex search-text})
                       (and search-by-dealer-code? (= "ITA" country-code))
                       ;; TODO define these by something else if we add more dealer codes
                       (assoc :external.kia/location-codes {:ductile.entity-search/regex search-text})
                       (and (not search-by-dealer-code?) (some-> search-text parse-long))
                       (assoc :address/postcode {:ductile.entity-search/regex search-text})
                       (and (not search-by-dealer-code?) (not (some-> search-text parse-long)))
                       (assoc :address/name {:ductile.entity-search/regex (str "(?i)" search-text)}))}))
         :input-placeholder (str (tr "Type to filter") "…")
         :button-placeholder (str (tr "Click to select") "…")
         :value (get-in @!vin->call-off-data [(:vehicle/vin fahrzeug) :fahrzeug/destination])
         :on-select-item (fn [selected-item]
                           (set-call-off-data! (:vehicle/vin fahrzeug)
                                               [:fahrzeug/destination]
                                               selected-item))
         :items @!destinations
         :selected-item-view item-view
         :item-view item-view}]]]
     (if (= "ITA" country-code)
       [:td.px-2.py-2.border-r
        [:span.text-xs (tr "Automatic")]]
       [:td.px-2.py-2.border-r
        [:div.flex.items-center.gap-3
         [ui/input {:type "date"
                    :style {:height 30 :padding-left 10 :padding-right 10 :font-size 13}
                    :default-value (:fahrzeug/expected-customer-delivery-datetime fahrzeug)
                    :on-input #(set-call-off-data! (:vehicle/vin fahrzeug) [:fahrzeug/expected-customer-delivery-datetime] (.. % -target -value))
                    :size 3}]
         [:label.text-xs.flex.items-center.gap-1
          [:input {:type :checkbox
                   :checked (contains? (set (get-in @!vin->call-off-data [(:vehicle/vin fahrzeug) :fahrzeug/priorities])) :prioritiy/binding-customer-appointment)
                   :on-change #(set-call-off-data! (:vehicle/vin fahrzeug)
                                                   [:fahrzeug/priorities]
                                                   (if (.. % -target -checked)
                                                     (set/union (set (:fahrzeug/priorities fahrzeug)) #{:prioritiy/binding-customer-appointment})
                                                     (set/difference (set (:fahrzeug/priorities fahrzeug)) #{:prioritiy/binding-customer-appointment})))}]
          [:span.text-base "🤝"] " " (tr "Binding")]]])
     [:td.px-2.py-2.border-r
      [combobox/view
       {:size 1
        :placeholder (tr "Add service")
        :value nil
        :data-testid "call-off-services-selection"
        :choices (->> (:fahrzeug/assignable-services fahrzeug)
                      (map ui/service-label)
                      (remove nil?)
                      sort
                      (map (fn [l] {:ui/label l :ui/value l})))
        :on-change (fn [{service-label :ui/label}]
                     (when-not (str/blank? service-label)
                       (deframe/tx! [[:op/merge-at [::state :vin->call-off-data (:vehicle/vin fahrzeug)]
                                      {:fahrzeug/assignable-services (set/difference
                                                                      (set (get-in @!vin->call-off-data
                                                                                   [(:vehicle/vin fahrzeug) :fahrzeug/assignable-services]))
                                                                      #{(find-service-by-label (:fahrzeug/assignable-services fahrzeug)
                                                                                               service-label)})
                                       :fahrzeug/services (conj
                                                           (get-in @!vin->call-off-data [(:vehicle/vin fahrzeug) :fahrzeug/services])
                                                           (find-service-by-label (:fahrzeug/assignable-services fahrzeug)
                                                                                  service-label))}]])))}]
      (into
       [:div.mt-1]
       (map
        (fn [service]
          (let [service-label (ui/service-label service)]
            [:div
             [:div.rounded-full.bg-indigo-700.text-white.inline-flex.items-center.hover:bg-red11.cursor-pointer.whitespace-nowrap
              {:class "text-[11px] pl-[5px] pr-[10px] py-[2px] gap-[2px]"
               :data-service-label (ui/service-label service)
               :on-click (fn [event]
                           (.preventDefault event)
                           (let [service-label (.. ^js event -target -dataset -serviceLabel)]
                             (deframe/tx! [[:op/merge-at [::state :vin->call-off-data (:vehicle/vin fahrzeug)]
                                            {:fahrzeug/assignable-services (set/union
                                                                            (set (:fahrzeug/assignable-services fahrzeug))
                                                                            #{(find-service-by-label (:fahrzeug/services fahrzeug)
                                                                                                     service-label)})
                                             :fahrzeug/services (remove (fn [service]
                                                                          (= service-label (ui/service-label service)))
                                                                        (get-in @!vin->call-off-data [(:vehicle/vin fahrzeug) :fahrzeug/services]))}]])))}
              [ui/icon {:width 12 :height 12 :class "pointer-events-none"} :trash]
              service-label]])))
       (:fahrzeug/services fahrzeug))]
     [:td.px-3.py-2
      [ui/button
       {:size 1
        :variant :destructive
        :on-click #(do (.preventDefault %)
                       (deframe/tx! [[:op/dissoc-in [::state :vin->call-off-data (:vehicle/vin fahrzeug)]]]))}
       [ui/icon :trash]
       (tr "Remove")]]]))

(defn vehicles-table [props]
  [:div.overflow-auto.bg-white.rounded.border.border-slate-300
   [:table.w-full
    [:thead.text-left.border-b-2.border-slate-300.text-xs
     [:tr
      [:th.px-3.py-2.bg-slate-100.border-r {:class "w-[270px]"} (tr "Vehicle")]
      [:th.px-2.py-2.bg-slate-100.border-r {:class "w-[480px]"} (tr "Destination")]
      [:th.px-2.py-2.bg-slate-100.border-r {:class "w-[290px]"} (tr "Appointment date")]
      [:th.px-2.py-2.bg-slate-100.border-r {:class "w-[270px]"} (tr "Services")]
      [:th.px-3.py-2.bg-slate-100 {:class "w-[140px]"} ""]]]
    (into
     [:tbody.align-top]
     (map (partial fahrzeug-row props))
     (vals @!vin->call-off-data))]])

(defn date->str [date]
  (let [month (inc (.getMonth date))
        day (.getDate date)]
    (str (.getFullYear date) "-"
         (when (< month 10) "0") month "-"
         (when (< day 10) "0") day)))

(defn show-error-toast! [error-message]
  (deframe/assoc!
   :toast
   {:title (str "❌ " (tr "There was an error when trying calling off the vehicles"))
    :description [:div.mb-3.leading-normal error-message]
    :variant :error}))

(defn show-success-toast! [{compound-name :compound/name} result]
  (deframe/assoc!
   :toast
   {:title (str "✅ " (tr "Called off %1 vehicles" (count (:called-off-vins result))))
    :description [:div.mb-3
                  [:div.leading-normal (tr "The following VINs have been called-off") ":"]
                  (into [:div.leading-normal]
                        (map-indexed (fn [i vin]
                                       [:span
                                        (when-not (zero? i) ", ")
                                        [ui/link {:href (str "/compound/" compound-name "/vehicle/" vin)
                                                  :data-testid (str vin "-called-off")} vin]])
                                     (:called-off-vins result)))]
    :action {:as :a
             :href (router/path '[compound :compound/name vehicle-call-off] {:compound/name compound-name})
             :variant :success
             :data-testid "call-off-created-toast-action"
             :label (str "🔍 " (tr "New call-off"))}
    :variant :success}))

(defn call-off-form [{:keys [meta notice] :as props}]
  [ui/panel {:variant :full}
   [ui/panel-content
    (when-let [notice @(deframe/!route-get ::notice)]
      [:div.overflow-hidden.rounded-lg.shadow-lg.mb-5
       [ui/flash-notice (assoc notice :on-close #(deframe/route-dissoc! ::notice))]])
    [:form
     {:on-submit (fn [event]
                   (.preventDefault event)
                   (-> (http/$lambda 'ductile.workflow.engine/handle-call-off-vehicles
                                     {:compound/name (:compound/name props)
                                      :fahrzeuge (update-vals @!vin->call-off-data
                                                              (fn [f]
                                                                (cond-> f
                                                                  (:fahrzeug/destination f) (assoc :exit/transport-order {:destination/location (:fahrzeug/destination f)})
                                                                  true (select-keys [:ductile/id
                                                                                     :exit/transport-order
                                                                                     :fahrzeug/services
                                                                                     :compound/name
                                                                                     :fahrzeug/expected-customer-delivery-datetime
                                                                                     :fahrzeug/priorities]))))})
                       (.then (fn [result]
                                (if (:error result)
                                  (show-error-toast! (:error-message result))
                                  (show-success-toast! props result))))))}
     [:h2.mb-2
      (tr "Vehicle call-off")]
     [:div.flex.justify-between.mb-3.items-end
      [:div.text-slate11 {:class "text-[15px]"}
       (tr "%1 vehicles selected" (count @!vin->call-off-data))]
      [:div.flex.items-center.gap-3
       [ui/button
        {:as :a
         :href (router/path '[compound :compound/name vehicle-call-off] (:path-params @deframe/!current-route))}
        (tr "Back to vehicle selection")]
       [ui/button
        {:variant :primary :type :submit
         :disabled? (zero? (count @!vin->call-off-data))
         :data-testid "confirm-call-off"}
        (tr "Call off all %1 VINs" (count @!vin->call-off-data))]]]
     (if (seq @!vin->call-off-data)
       [vehicles-table props]
       [:div.text-slate11.text-sm (tr "No vehicles selected to call-off. Select some vehicles first.")])]]])

(defn render-vehicle-call-off [{:as match :keys [path-params]} _result]
  [call-off-form path-params])

(defn init-call-off-data [vin->call-off-data]
  (update-vals vin->call-off-data #(-> %
                                       (assoc :fahrzeug/services (:service.event/ordered %))
                                       (update :fahrzeug/expected-customer-delivery-datetime
                                               (fn [d] (if d
                                                         (date->str d)
                                                         (date->str (:fahrzeug/suggested-appointment-date %))))))))

(defn continue!
  "This is called from vehicle-search for the :call-off use case."
  [search-params]
  (-> (http/$lambda 'ductile.workflow.engine/call-off-search {:search-params search-params})
      (.then (fn [{:as result :keys [error vin->fahrzeug destinations]}]
               (cond
                 error
                 (show-error-toast! (:error-message result))

                 (:router/navigate-to result)
                 (router/navigate-to (router/path (:router/navigate-to result)
                                                  (:router/path-params result)))

                 :else
                 (do
                   (deframe/assoc! ::state {:destinations destinations
                                            :vin->call-off-data (init-call-off-data vin->fahrzeug)})
                   (router/navigate-to (router/path '[compound :compound/name vehicle-call-off service-selection]
                                                    (:path-params @deframe/!current-route)))))))))
